export default "/app/global-wrapper-client/static/53320d12c285184f1d3316d00bb2d7b0.ttf";